import { render, staticRenderFns } from "./testProducts.vue?vue&type=template&id=1cb2e93c&scoped=true"
import script from "./testProducts.vue?vue&type=script&lang=js"
export * from "./testProducts.vue?vue&type=script&lang=js"
import style0 from "./testProducts.vue?vue&type=style&index=0&id=1cb2e93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb2e93c",
  null
  
)

export default component.exports